import * as moment from "moment";
import { stateConvert } from "web/components/utils/stateAbbreviation";

export const scheduledPostsCsvExportHeader = [
  { id: "refNo", displayName: "Ref No" },
  { id: "customerName", displayName: "Customer Name" },
  { id: "poNumber", displayName: "P.O. Number" },
  { id: "orderNumber", displayName: "Order Number" },
  { id: "locationName", displayName: "Location Name" },
  { id: "addressCityState", displayName: "Address-City State" },
  { id: "type", displayName: "Type" },
  { id: "quantityOrderType", displayName: "Quantity-Order Type" },
  { id: "rdd", displayName: "Req. Del/Pickup Date" },
  { id: "supplierNameCityState", displayName: "Supplier Name-City-State" },
  { id: "supplierEmail", displayName: "Supplier Email" },
  { id: "supplierPhoneNo", displayName: "Supplier Phone No" },
  { id: "price", displayName: "Supplier Price" },
  { id: "status", displayName: "Status" },
  { id: "tenderedDate", displayName: "Tendered Date" },
];

export const setScheduledPostsCsvExportData = (pagedata) => {
  const orderType = (items) => {
    let totalQuantity = items?.quantityDetails?.totalQuantity

    if (items?.requestType === 'PickUp') return totalQuantity + '-NA'

    let condition
    if (items?.palletDetails?.condition?.length !== 1) {
      condition = items?.palletDetails?.condition?.join("-")
    } else {
      if (items?.palletDetails?.condition.length !== 0)
        condition = items?.palletDetails?.condition
    }

    let palletType;
    let size = "";
    let grade = "";
    let LWH
    if (items?.palletDetails?.material !== "WOOD") {
      const length = items?.palletDetails?.length
      const width = items?.palletDetails?.width
      const height = items?.palletDetails?.height
      LWH = length + "x" + width + "x" + height
      if (condition) {
        condition = condition?.toString()
        condition = condition?.toLowerCase();
        condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

        return totalQuantity + "-" + LWH + "-" + condition
      } else {
        return totalQuantity + "-" + LWH
      }

    } else {
      palletType = items?.palletDetails?.palletType

      if (items?.palletDetails?.size)
        size = "-" + items?.palletDetails?.size

      if (items?.palletDetails?.grade)
        grade = "-" + items?.palletDetails?.grade

      palletType = palletType?.toLowerCase();
      palletType = palletType?.replace(/\b\w/g, c => c.toUpperCase())
      condition = condition?.toString()
      condition = condition?.toLowerCase();
      condition = condition?.replace(/\b\w/g, c => c.toUpperCase())

      if (items?.palletDetails?.newConditionType) {
        let newConditionType
        if (items?.palletDetails?.newConditionType === 'HARDWOOD') newConditionType = '(HW)'
        else if (items?.palletDetails?.newConditionType === 'SOFTWOOD') newConditionType = '(SW)'
        if (newConditionType) condition = `${condition} ${newConditionType}`
      }

      return totalQuantity + "" + size + "" + grade + "-" + palletType + "-" + condition
    }
  }

  return pagedata?.map(items => ({
    refNo: items.orderRefNumber || "NA",
    customerName: items?.addressDTO?.name?.replace(/,|\n|\r/g, " ") || "NA",
    poNumber: items.poNumber || "NA",
    orderNumber: items.orderNo && items.orderNo !== '' ? items.orderNo : "NA",
    locationName: items?.ptPostedDetailsDTO?.shippingAddress?.locationName?.replace(/,|\n|\r/g, " ") ||
      items?.addressDTO?.locationName?.replace(/,|\n|\r/g, " ") || "NA",
    addressCityState: items?.ptPostedDetailsDTO?.shippingAddress
      ? `${items?.ptPostedDetailsDTO?.shippingAddress?.street?.replace(/,|\n|\r/g, " ")}-${items?.ptPostedDetailsDTO?.shippingAddress?.city?.replace(/,|\n|\r/g, " ")} ${stateConvert(items?.ptPostedDetailsDTO?.shippingAddress?.state) || items?.ptPostedDetailsDTO?.shippingAddress?.state
      }`
      : items.addressDTO
        ? `${items.addressDTO.street?.replace(/,|\n|\r/g, " ")}-${items.addressDTO.city?.replace(/,|\n|\r/g, " ")}-${stateConvert(items.addressDTO.state) || items.addressDTO.state
        }`
        : "NA",
    type: items.requestType === 'PickUp' ? 'Pickup' : 'Delivery',
    quantityOrderType: orderType(items),
    rdd: items.requestType === 'PickUp'
      ? `${moment(items.requestDeliveryDate).format('MM/DD/YYYY')} ${items.deliveryFromTime}-${items.deliveryToTime}`
      : items?.ptPostedDetailsDTO
        ? `${moment(items?.ptPostedDetailsDTO?.requestDeliveryDate).format('MM/DD/YYYY')} ${items.ptPostedDetailsDTO?.deliveryWindowBegin &&
          items.ptPostedDetailsDTO?.deliveryWindowEnd &&
          items.ptPostedDetailsDTO?.deliveryWindowEnd !== 'null'
          ? items.ptPostedDetailsDTO?.deliveryWindowBegin + '-' + items.ptPostedDetailsDTO?.deliveryWindowEnd
          : items.ptPostedDetailsDTO?.deliveryWindowBegin || 'NA'
        }`
        : `${moment(items.requestDeliveryDate).format('MM/DD/YYYY')} ${items.deliveryFromTime}-${items.deliveryToTime}`,
    supplierNameCityState: items?.tenderDetails
      ? `${items?.tenderDetails.postedTo?.replace(/,|\n|\r/g, " ") || 'NA'}-${items?.tenderDetails.city?.replace(/,|\n|\r/g, " ")}-${stateConvert(items?.tenderDetails.state) || items?.tenderDetails.state}`
      : "NA",
    supplierEmail: (items?.tenderDetails?.email && items?.tenderDetails?.email[0]) ? `"${items.tenderDetails.email.join(', ')}"` : 'NA',
    supplierPhoneNo: (items?.tenderDetails?.phoneNumber && items?.tenderDetails?.phoneNumber[0]) ? `"${items.tenderDetails.phoneNumber.join(', ')}"` : 'NA',
    price: (items?.tenderDetails?.vendorPrice && items?.tenderDetails?.vendorPrice?.length >= 1) ?
      items?.tenderDetails?.vendorPrice?.map(price => `$${Number(price).toFixed(2)}`).join(' ')
      : "NA",
    status: items.orderStatus === "CANCELLED" ? "CANCELED" : items.orderStatus || "NA",
    tenderedDate: items?.tenderDetails?.tenderDate
      ? items?.tenderDetails?.tenderDate
      : moment(items?.createdAt * 1000).format("MM/DD/YYYY") || "NA",
  }));
};

